import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { toThunkRejectValue } from "../../../../Common/isRequestCanceled";
import {
  BASE_NODE_URL,
  BASE_URL,
  EXPORT_DATA_MAIL_API,
  NEW_CUSTOMER_ADDED_REPORT,
} from "../../../../Constants/Config";

const initialState = {
  loading: false,
  NewCustomersAddedReportArr: [],
  totalCount: 0,
  status: false,
  successMessage: "",
  error: "",
};

let abortNewCustomerAddedReport = null;
let abortExportReport = null;

export const fetchNewCustomersAddedReportArr = createAsyncThunk(
  "NewCustomersAddedReport/fetchNewCustomersAddedReportArr",
  async (data, { rejectWithValue }) => {
    if (abortNewCustomerAddedReport) {
      abortNewCustomerAddedReport.abort();
    }

    abortNewCustomerAddedReport = new AbortController();
    const signal = abortNewCustomerAddedReport.signal;
    try {
      const { token, ...dataNew } = data;
      const res = await axios.post(
        BASE_URL + NEW_CUSTOMER_ADDED_REPORT,
        dataNew,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`,
          },
          signal,
        }
      );
      // console.log(res.data);
      if (res.data.status === true) {
        const arr = res.data.new_customer_list;
        const status = res.data.status;
        const totalCount = res.data.total_records;

        return { arr, status, totalCount };
      } else if (res.data.status === false) {
        const arr = [];
        const status = false;
        const totalCount = 0;
        return { arr, status, totalCount };
      }
    } catch (error) {
      const customError = {
        message: toThunkRejectValue(error).message,
        status: toThunkRejectValue(error).status,
        data: error.response ? error.response.data : null,
      };
      return rejectWithValue(customError);
    }
  }
);

export const fetchExportReportByMail = createAsyncThunk(
  "NewCustomersAddedReport/fetchExportReportByMail",
  async (data, { rejectWithValue }) => {
    // console.log("data", data);
    if (abortExportReport) {
      abortExportReport.abort();
    }

    abortExportReport = new AbortController();
    const signal = abortExportReport.signal;

    try {
      const { token, ...dataNew } = data;
      const res = await axios.post(
        // BASE_URL + NEW_CUSTOMER_ADDED_REPORT,
        BASE_NODE_URL+ EXPORT_DATA_MAIL_API,
        dataNew,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`,
          },
          signal,
        }
      );
      return res.data;
    } catch (error) {
      const customError = {
        message: toThunkRejectValue(error).message,
        status: toThunkRejectValue(error).status,
        data: error.response ? error.response.data : null,
      };
      return rejectWithValue(customError);
    }
  }
);

const NewCustomersAddedReportSlice = createSlice({
  name: "NewCustomersAddedReport",
  initialState,
  extraReducers: (builder) => {
    builder.addCase(fetchNewCustomersAddedReportArr.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(
      fetchNewCustomersAddedReportArr.fulfilled,
      (state, action) => {
        state.loading = false;
        state.NewCustomersAddedReportArr = action.payload.arr;
        state.totalCount = action.payload.totalCount;
        state.status = action.payload.status;
        state.error = "";
      }
    );
    builder.addCase(
      fetchNewCustomersAddedReportArr.rejected,
      (state, action) => {
        state.loading = false;
        state.NewCustomersAddedReportArr = [];
        state.error = action.error.message;
      }
    );
  },
});
export default NewCustomersAddedReportSlice.reducer;
